import { render } from "./UserPicList.vue?vue&type=template&id=7f601552&scoped=true"
import script from "./UserPicList.vue?vue&type=script&lang=js"
export * from "./UserPicList.vue?vue&type=script&lang=js"

import "./UserPicList.vue?vue&type=style&index=0&id=7f601552&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f601552"

export default script